module.exports = __webpack_public_path__ + "static/img/kj.d5b6c3a2.png";